document.addEventListener('DOMContentLoaded', function () {
  const cards = document.querySelectorAll('.card-wrapper');

  cards.forEach(function (card) {
    card.addEventListener('touchstart', function () {
      card.classList.add('hover-active');
    }, { passive: true });

    card.addEventListener('touchend', function () {
      setTimeout(() => card.classList.remove('hover-active'), 500);
    }, { passive: true });
  });
});